import React from 'react'

export const Skeleton = ({index}:any) => {
  return (
    <>
    <div key={index} className={`rounded-xl  border-2 border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-md`}>
      <div className="p-2">
        <div className="flex items-center space-x-4 animate-pulse">
          <div className="w-8 h-8 bg-gray-300 rounded-sm" />
          <div className="h-4 bg-gray-300 rounded w-32" />
        </div>
      </div>
      <div className="w-full border-t border-dashed border-gray-200" />
  
      <div className="grid grid-cols-3 gap-28 sm:gap-6 px-4 py-2 animate-pulse ">
        <div>
          <div className="h-4 bg-gray-300 rounded w-20 mb-2" />
          <div className="h-4 bg-gray-200 rounded w-28" />
        </div>
        <div>
          <div className="h-4 bg-gray-300 rounded w-20 mb-2" />
          <div className="h-4 bg-gray-200 rounded w-32" />
        </div>
      </div>
    </div>
  </>
  
  )
}
